module.exports = __webpack_public_path__ + "img/logo_login1.26ba61b4.png";